<template>
    <v-form v-model="valid">
        <v-container fluid>
            <v-col cols="12" md="3" class="select-editorial">
                <v-autocomplete v-model="idEditorial"
                                item-text="nombre"
                                item-value="idEditorial"
                                :items="editoriales"
                                label="Seleccione una editorial"
                                @change="blurEditorial">
                </v-autocomplete>
            </v-col>
        </v-container>
    </v-form>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Editoriales',
        props: ['criterio'],
        computed: {
            ...mapState(['editoriales'])

        },
        data() {
            return {
                valid: true,
                idEditorial: null
            }
        },
        mounted() {
            this.idEditorial = this.criterio.idEditorial == null ? this.editoriales[0].idEditorial : this.criterio.idEditorial;
        },
        methods: {
            blurEditorial(value) {
                let editorial = this.editoriales.find(x => x.idEditorial == value);
                this.$emit('getEditorial', editorial);
            }

        }
    }
</script>

<style>
    .v-input.v-text-field {
        margin-top: 0;
        padding-top: 0;
    }

    .right {
        float: right;
    }

    .select-editorial .theme--light.v-label,
    .select-editorial .theme--light.v-label.v-label--active,
    .select-editorial .theme--light.v-input:not(.v-input--is-disabled) input,
    .select-editorial .theme--light.v-icon,
    .select-editorial .v-input--is-focused .theme--light.v-icon {
        color: #fff !important;
    }

    .select-editorial .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: #fff !important;
    }

    .select-editorial {
        padding: 0 !important;
        margin-top: 39px;
        margin-left: -11px;
    }
    .select-editorial .v-list-item__title {
        text-align: left;
    }
</style>